import React from 'react';
import { Music, MusicOff } from 'tabler-icons-react';
import { useAudio } from '../context/AudioContext';
import Tooltip from './Tooltip';

interface MusicToggleProps {
  onClick?: () => void;
}

const MusicToggle: React.FC<MusicToggleProps> = ({ onClick }) => {
  const { isMusicEnabled, toggleMusic, isMusicButtonDisabled } = useAudio();

  const handleClick = () => {
    if (isMusicButtonDisabled) return;

    toggleMusic();
    if (onClick) onClick();
  };

  return (
    <Tooltip
      content={isMusicEnabled ? 'Desactivar Música' : 'Activar Música'}
      position="right"
    >
      <button
        onClick={handleClick}
        className={`icon-bg relative overflow-hidden audio-control-button ${
          isMusicButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
        title={isMusicEnabled ? 'Desactivar Música' : 'Activar Música'}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className={`absolute transition-all duration-300 ease-in-out transform ${
              isMusicEnabled
                ? 'opacity-100 rotate-0 scale-100'
                : 'opacity-0 -rotate-90 scale-50'
            }`}
          >
            <Music className="text-white w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 lg:w-9 lg:h-9" />
          </div>
          <div
            className={`absolute transition-all duration-300 ease-in-out transform ${
              !isMusicEnabled
                ? 'opacity-100 rotate-0 scale-100'
                : 'opacity-0 rotate-90 scale-50'
            }`}
          >
            <MusicOff className="text-white w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 lg:w-9 lg:h-9" />
          </div>
        </div>
      </button>
    </Tooltip>
  );
};

export default MusicToggle;
